import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";

interface UseProductGeneralInformationParams {
    data?: DstProductDetailViewModel;
    labels: DstProductDetailLabels;
    loading: boolean;
}

interface UseProductGeneralInformationReturn {
    showSkeleton: boolean;
    hasContent: boolean;
    cardTitle: string;
    descriptionHtml: string | undefined;
}

export const useProductGeneralInformation = ({
    data,
    labels,
    loading,
}: UseProductGeneralInformationParams): UseProductGeneralInformationReturn => {
    const descriptionHtml = data?.description ?? undefined;
    const hasContent = !!descriptionHtml;
    const showSkeleton = loading;

    return {
        showSkeleton,
        hasContent,
        cardTitle: labels.generalInformation,
        descriptionHtml,
    };
};
